(function () {
    const sliders = document.querySelectorAll('.media');
    const clickThreshold = 200; // milliseconds
    const breakPoint = 750; // px
    const swipeThreshold = 50; // Increased minimum pixel difference to consider a swipe
    const verticalDeadZone = 30; // Pixel threshold for vertical movement to allow scrolling
    const swipeTimeThreshold = 300; // Maximum time in milliseconds for a swipe

    function initializeSlider(slider) {
        const sliderWidth = slider.clientWidth;
        const images = slider.querySelectorAll('img');

        // Add click event listener
        slider.addEventListener('click', handleClick);

        // Abort if only one image
        if (images.length <= 1) return;

        let startX, startY, startTime;
        let isDragging = false;
        let currentIndex = 0;
        let clickStartTime;
        let isHorizontalSwipe = false;

        slider.addEventListener('mousedown', startDrag);
        slider.addEventListener('touchstart', startDrag);

        slider.addEventListener('mousemove', drag);
        slider.addEventListener('touchmove', drag);

        slider.addEventListener('mouseup', endDrag);
        slider.addEventListener('mouseleave', endDrag);
        slider.addEventListener('touchend', endDrag);

        function startDrag(e) {
            isDragging = true;
            startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
            startY = e.type.includes('mouse') ? e.pageY : e.touches[0].pageY;
            startTime = new Date().getTime();
            clickStartTime = startTime;
            isHorizontalSwipe = false;

            // Remove transition during drag for responsive feel
            images.forEach(img => {
                img.style.transition = 'none';
            });
        }

        function drag(e) {
            if (!isDragging) return;
            
            const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
            const currentY = e.type.includes('mouse') ? e.pageY : e.touches[0].pageY;
            const diffX = startX - currentX;
            const diffY = startY - currentY;

            // Check if the movement is primarily horizontal and outside the vertical dead zone
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffY) < verticalDeadZone) {
                e.preventDefault(); // Prevent scrolling only for horizontal swipes
                isHorizontalSwipe = true;
                const offsetPercentage = (diffX / sliderWidth) * 100;

                images.forEach((img, index) => {
                    const baseOffset = (index - currentIndex) * 100;
                    img.style.transform = `translateX(${baseOffset - offsetPercentage}%)`;
                });
            } else {
                // Allow default behavior (scrolling) for vertical movements
                isHorizontalSwipe = false;
            }
        }

        function endDrag(e) {
            if (!isDragging) return;
            isDragging = false;

            // Restore transitions
            images.forEach(img => {
                img.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
            });

            const endX = e.type.includes('mouse') ? e.pageX : e.changedTouches[0].pageX;
            const endY = e.type.includes('mouse') ? e.pageY : e.changedTouches[0].pageY;
            const diffX = startX - endX;
            const diffY = startY - endY;
            const endTime = new Date().getTime();
            const swipeDuration = endTime - startTime;

            // Check if the movement is primarily horizontal, exceeds the swipe threshold, and is within the time threshold
            if (isHorizontalSwipe && Math.abs(diffX) > swipeThreshold && swipeDuration < swipeTimeThreshold) {
                if (diffX > 0 && currentIndex < images.length - 1) {
                    // Swipe to next image
                    currentIndex++;
                } else if (diffX < 0 && currentIndex > 0) {
                    // Swipe to previous image
                    currentIndex--;
                }
            }

            updateSliderPosition();
        }

        function updateSliderPosition() {
            images.forEach((img, index) => {
                const offset = (index - currentIndex) * 100;
                img.style.transform = `translateX(${offset}%)`;

                // Explicitly set opacity based on current index
                if (index === currentIndex) {
                    img.style.opacity = 1;
                } else {
                    img.style.opacity = 0;
                }

                // Ensure second image has opacity 0 when first image is current
                if (currentIndex === 0 && index === 1) {
                    img.style.opacity = 0;
                }
            });
        }

        function handleClick(e) {
            const clickEndTime = new Date().getTime();
            const clickDuration = clickEndTime - clickStartTime;

            // Only treat it as a click if the duration is less than the threshold
            if (clickDuration < clickThreshold) {
                const url = slider.getAttribute('data-url');
                if (url) {
                    window.location.href = url;
                }
            }
        }

        // Initialize slider position
        updateSliderPosition();
    }

    // Initialize all sliders
    if (window.innerWidth < breakPoint) {
        sliders.forEach(slider => initializeSlider(slider));
    }
})();